<template>
    <div>

    </div>
</template>

<script>
    /* global FB */

    import vanilla from '../../services/vanilla'
    import {
        LOADING_STARTED,
        LOADING_COMPLETED_SUCCESS,
        LOADING_COMPLETED_FAILURE,
        SET_FACEBOOK_SDK_STATE,
    } from '../../services/constants'

    export default {
        name: 'facebook-sdk',
        props: {},
        data() {
            return {
                nativeWindow: null,
                nativeDocument: null,
                facebookSdkScriptTag: null,
            }
        },
        computed: {
            appId() {
                return this.$store.state.integrationsModule.facebook.appId
            }
        },
        methods: {
            init() {

                this.$store.commit(SET_FACEBOOK_SDK_STATE, {
                    state: LOADING_STARTED,
                    data: null,
                    error: null,
                })
                this.nativeWindow.fbAsyncInit = this.fbAsyncInit

                const id = 'facebook-jssdk'
                const tagName = 'script'
                if (this.nativeDocument.getElementById(id)) {
                    return
                }

                const firstScriptTagOnDocument = this.nativeDocument.getElementsByTagName(tagName)[0];
                this.facebookSdkScriptTag = this.nativeDocument.createElement(tagName)
                this.facebookSdkScriptTag.id = id
                this.facebookSdkScriptTag.src = 'https://connect.facebook.net/en_US/sdk.js'
                this.facebookSdkScriptTag.addEventListener('error', this.onFacebookSdkScriptTagError)

                firstScriptTagOnDocument.parentNode.insertBefore(this.facebookSdkScriptTag, firstScriptTagOnDocument)
            },
            onFacebookSdkScriptTagError(evt) {
                this.$store.commit(SET_FACEBOOK_SDK_STATE, {
                    state: LOADING_COMPLETED_FAILURE,
                    data: null,
                    error: new Error('Error loading external Facebook SDK script'),
                })
                this.unhookErrorListener()
            },
            fbAsyncInit() {
                this.unhookErrorListener()
                FB.init({
                    appId: this.appId,
                    autoLogAppEvents: true,
                    xfbml: true,
                    version: 'v3.2'
                });
                this.$store.commit(SET_FACEBOOK_SDK_STATE, {
                    state: LOADING_COMPLETED_SUCCESS,
                    data: FB,
                    error: null,
                })
            },
            unhookErrorListener() {
                this.facebookSdkScriptTag.removeEventListener('error', this.onFacebookSdkScriptTagError)
            }
        },
        created() {
            this.nativeWindow = vanilla.getNativeWindowObject()
            this.nativeDocument = vanilla.getNativeDocumentObject()
            this.init()
        }

    }
</script>

<style scoped lang="scss">

</style>
